"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeroEventRecurrenceEnum = void 0;
var HeroEventRecurrenceEnum;
(function (HeroEventRecurrenceEnum) {
    HeroEventRecurrenceEnum["WEEKLY"] = "weekly";
    HeroEventRecurrenceEnum["DAILY"] = "daily";
    HeroEventRecurrenceEnum["MONTHLY"] = "monthly";
    HeroEventRecurrenceEnum["ONE_TIME"] = "one-time";
})(HeroEventRecurrenceEnum || (exports.HeroEventRecurrenceEnum = HeroEventRecurrenceEnum = {}));
